export default function MobileError({ message, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center" role="alert">
      <p className="text-base text-laranjinha/80">{message}</p>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg bg-primary px-6 font-medium text-mgs-bg hover:bg-[#b47c06]"
        >
          Tentar novamente
        </button>
      ) : null}
    </div>
  );
}
